import { makeStaticStyles, tokens } from '@fluentui/react-components';

const useStaticStyles = makeStaticStyles({
	'html': {
		height: '100%',
	},
	'body': {
		margin: '0px',
		height: '100%',
	},
	'#root': {
		height: '100%',
	},
	'&::-webkit-scrollbar': {
		height: '5px',
		width: '5px',
	},
	'&::-webkit-scrollbar-thumb': {
		borderRadius: '5px',
		background: tokens.colorScrollbarOverlay,
	},
	'&::-webkit-scrollbar-track': {
		background: 'white',
	},
	'.stackPanel': {
		backgroundColor: tokens.colorNeutralBackground1,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
	},
});

export default useStaticStyles;
